// extracted by mini-css-extract-plugin
export var csatScore = "_mf-5";
export var header = "_mf-1";
export var panelWrapper = "_mf-2";
export var postPreview = "_mf-3";
export var rightContent = "_mf-0";
export var wrappingText = "_mf-4";